import React, { useState, useEffect } from 'react';
import { CheckboxControl, DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';

const PublishDialog = ({ isActive, closeDialog }) => {
  const { dashboardLib, switchMode } = useDashboardDomainContext();

  const [error, setError] = useState(false);
  const [newPublicState, setNewPublicState] = useState(
    dashboardLib?.activeDashboard?.State?.IsPublic ?? false
  );
  const hasTitle = !!dashboardLib?.activeDashboard?.DraftDetails?.Name;

  useEffect(() => {
    if (isActive) {
      setNewPublicState(dashboardLib?.activeDashboard?.State?.IsPublic ?? false);
    }
  }, [isActive, dashboardLib?.activeDashboard?.State?.IsPublic]);

  return (
    <DialogControl
      className="dashboard-dialog"
      openDialog={isActive}
      title="Publish Dashboard"
      onOk={async () => {
        return dashboardLib
          .publishDashboard(newPublicState)
          .then((status) => {
            if (status === 200) {
              closeDialog();
              setNewPublicState(dashboardLib?.activeDashboard?.State?.IsPublic ?? false);
              switchMode('view');
              setError(false);
            }
          })
          .catch((status) => {
            if (status !== 200) setError(true);
          });
      }}
      onCancel={() => {
        closeDialog();
        setNewPublicState(dashboardLib?.activeDashboard?.State?.IsPublic ?? false);
        setError(false);
      }}
      okText="Publish"
      disableOk={!hasTitle}
    >
      <div className="dialog-text">
        {!hasTitle ? (
          <div style={{ whiteSpace: 'pre-wrap' }} className="error">
            The dashboard you want to publish is missing a title. Please return and add a title before publishing.
          </div>
        ) : !error ? (
          <>
            Please confirm that you want to publish this dashboard.
            <div className="dialog-checkbox">
              <CheckboxControl
                value={newPublicState}
                onChange={() => setNewPublicState(!newPublicState)}
              />
              <span>Make this dashboard public</span>
            </div>
          </>
        ) : (
          <div style={{ whiteSpace: 'pre-wrap' }} className="error">
            There has been an error with publishing this dashboard. <br />
            Please try again.
          </div>
        )}
      </div>
    </DialogControl>
  );
};

export default PublishDialog;
